import {
  CART_COOKIE_MAX_AGE,
  CART_COOKIE_NAME,
  CHANNEL,
  getChannelId,
} from 'config'
import Cookies from 'js-cookie'
import { getSession } from 'next-auth/react'
import { cartCreate } from './api/cart-create'
import { getCart } from './api/get-cart'

export function removeCartCookie() {
  try {
    Cookies.remove(CART_COOKIE_NAME)
  } catch (e) {
    console.error('Error removing checkout cookie', e)
  }
}

export function getCartIdFromCookies() {
  const cartId = Cookies.get(CART_COOKIE_NAME) || null
  return cartId
}

export function saveCartIdToCookie(cartId: string, callback?: () => void) {
  const shouldUseHttps = process.env.NODE_ENV?.startsWith('https')
  Cookies.set(CART_COOKIE_NAME, cartId, {
    sameSite: 'lax',
    secure: shouldUseHttps,
    expires: CART_COOKIE_MAX_AGE,
  })

  if (callback) {
    callback()
  }
}

export async function findOrCreateCart({
  cartId,
  channel,
  currency,
  countryCode,
}: {
  cartId: string
  channel: CHANNEL
  currency: string
  countryCode: string
}) {
  if (!cartId) {
    const session = await getSession()
    return (
      await cartCreate({
        channelId: getChannelId(channel),
        currency,
        customerId: session?.user?.id ?? null,
        lineItems: [],
        ...(countryCode?.toLowerCase() != 'us'
          ? {
              shippingAddress: {
                countryCode,
              },
            }
          : {}),
      })
    ).cartCreate?.cart
  }
  const cart = await getCart(cartId)
  return (
    cart ||
    (
      await cartCreate({
        channelId: getChannelId(channel),
        currency,
        lineItems: [],
      })
    ).cartCreate?.cart
  )
}
